"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fromUnixTime = _interopRequireDefault(require("date-fns/fromUnixTime"));
var _Button = _interopRequireDefault(require("../Button"));
var _Button2 = require("../Button/Button");
var _date = require("../../utils/date");
var _excluded = ["body", "createdAt", "downloadLink", "from", "subject", "to"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DATE_FORMAT = 'd MMM yyyy г., HH:mm';
var emailsRenderer = function emailsRenderer(emails) {
  return emails.map(function (_ref) {
    var name = _ref.name,
      email = _ref.email;
    return /*#__PURE__*/_react["default"].createElement(StyledEmail, {
      key: email
    }, name ? "".concat(name, " <").concat(email, ">") : email);
  });
};
var EmailPreview = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var body = _ref2.body,
    createdAt = _ref2.createdAt,
    downloadLink = _ref2.downloadLink,
    from = _ref2.from,
    subject = _ref2.subject,
    to = _ref2.to,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var date = (0, _fromUnixTime["default"])(createdAt);
  var createDateLabel = (0, _date.formatDate)(date, DATE_FORMAT);
  var handlePrint = (0, _react.useCallback)(function () {
    window.print();
  });
  return /*#__PURE__*/_react["default"].createElement(StyledEmailPreview, rest, /*#__PURE__*/_react["default"].createElement(StyledPrintable, null, /*#__PURE__*/_react["default"].createElement(StyledFields, null, /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledField, null, /*#__PURE__*/_react["default"].createElement(StyledFieldLabel, null, "\u0421\u043E\u0437\u0434\u0430\u043D\u043E:"), /*#__PURE__*/_react["default"].createElement(StyledFieldValue, null, createDateLabel)), /*#__PURE__*/_react["default"].createElement(StyledField, null, /*#__PURE__*/_react["default"].createElement(StyledFieldLabel, null, "\u041E\u0442:"), /*#__PURE__*/_react["default"].createElement(StyledFieldValue, null, emailsRenderer(from))), /*#__PURE__*/_react["default"].createElement(StyledField, null, /*#__PURE__*/_react["default"].createElement(StyledFieldLabel, null, "\u041A\u043E\u043C\u0443:"), /*#__PURE__*/_react["default"].createElement(StyledFieldValue, null, emailsRenderer(to))), /*#__PURE__*/_react["default"].createElement(StyledField, null, /*#__PURE__*/_react["default"].createElement(StyledFieldLabel, null, "\u0422\u0435\u043C\u0430:"), /*#__PURE__*/_react["default"].createElement(StyledFieldValue, null, subject)))), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledBody, {
    dangerouslySetInnerHTML: {
      __html: body
    }
  }))), /*#__PURE__*/_react["default"].createElement(StyledActions, null, /*#__PURE__*/_react["default"].createElement(StyledPrintButton, {
    onClick: handlePrint,
    size: _Button2.Sizes.TINY
  }, "\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C..."), downloadLink && /*#__PURE__*/_react["default"].createElement(StyledSaveLink, {
    href: downloadLink,
    target: "_blank"
  }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C PDF")));
});
var emailProptype = _propTypes["default"].shape({
  name: _propTypes["default"].string,
  email: _propTypes["default"].string
});
EmailPreview.displayName = 'EmailPreview';
EmailPreview.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].number,
  subject: _propTypes["default"].string,
  from: _propTypes["default"].arrayOf(emailProptype),
  to: _propTypes["default"].arrayOf(emailProptype),
  body: _propTypes["default"].string,
  createdAt: _propTypes["default"].number,
  downloadLink: _propTypes["default"].string,
  link: _propTypes["default"].string
};
EmailPreview.defaultProps = {
  className: '',
  id: null,
  subject: null,
  from: [],
  to: [],
  body: null,
  createdAt: null,
  downloadLink: null,
  link: null
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledWrapper",
  componentId: "sc-ss3wio-0"
})(["max-width:1160px;padding:16px 20px;margin:0 auto;"]);
var StyledPrintable = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledPrintable",
  componentId: "sc-ss3wio-1"
})([""]);
var StyledEmail = _styledComponents["default"].span.withConfig({
  displayName: "EmailPreview__StyledEmail",
  componentId: "sc-ss3wio-2"
})(["margin-right:15px;"]);
var StyledEmailPreview = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledEmailPreview",
  componentId: "sc-ss3wio-3"
})(["font-size:14px;"]);
var StyledFields = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledFields",
  componentId: "sc-ss3wio-4"
})(["background:white;width:100%;"]);
var StyledField = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledField",
  componentId: "sc-ss3wio-5"
})(["display:flex;padding:12px 0;border-bottom:1px solid #e6e9ee;"]);
var StyledFieldLabel = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledFieldLabel",
  componentId: "sc-ss3wio-6"
})(["width:300px;font-weight:500;"]);
var StyledFieldValue = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledFieldValue",
  componentId: "sc-ss3wio-7"
})(["flex:1;display:flex;flex-flow:wrap;"]);
var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "EmailPreview__StyledBody",
  componentId: "sc-ss3wio-8"
})(["padding:25px 23px;overflow-x:auto;overflow-y:hidden;color:#4d4d4d;line-height:18px;width:100%;background:white;border-radius:4px;"]);
var StyledActions = (0, _styledComponents["default"])(StyledWrapper).withConfig({
  displayName: "EmailPreview__StyledActions",
  componentId: "sc-ss3wio-9"
})(["display:flex;padding:0 20px 16px;@media print{display:none;}"]);
var StyledPrintButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "EmailPreview__StyledPrintButton",
  componentId: "sc-ss3wio-10"
})(["width:145px;margin-right:8px;border:none;font-weight:500;height:36px;line-height:36px;background:#007aff;color:white;&:hover{color:white;}"]);
var StyledSaveLink = _styledComponents["default"].a.withConfig({
  displayName: "EmailPreview__StyledSaveLink",
  componentId: "sc-ss3wio-11"
})(["width:145px;border:1px solid;text-align:center;height:36px;text-decoration:none;line-height:36px;box-sizing:border-box;color:#007aff;border-color:#007aff;border-radius:4px;"]);
var _default = exports["default"] = EmailPreview;